/**
 * Ajoute automatiquement le "Coffee shaker" (variant ID ci-dessous) au panier
 * dès qu'un produit café Proffee y est présent, et le retire s'il n'y a plus
 * de café dans le panier. Le produit est rendu gratuit via une remise
 * automatique -100% côté Shopify (Discounts > Coffee shaker offert
 * automatiquement), ce script ne gère que la présence/absence dans le panier.
 */
(function () {
  var GIFT_VARIANT_ID = 58383122760029; // Coffee shaker - Default Title
  var GIFT_PRODUCT_HANDLE = 'mousseur-electrique-copie';

  // Handles des produits "café" qui déclenchent l'ajout du cadeau.
  var TRIGGER_PRODUCT_HANDLES = [
    'cafe-instantane-proteine-jly',
    'cafe-instantane-proteine-smy',
    'cafe-instantane-proteine-rdy',
    'cafe-instantane-proteine-gene-copy',
    'cafe-instantane-proteine-gene'
  ];

  var isSyncing = false;

  function cartHasTrigger(cart) {
    return cart.items.some(function (item) {
      return TRIGGER_PRODUCT_HANDLES.indexOf(item.handle) !== -1;
    });
  }

  function cartHasGift(cart) {
    return cart.items.some(function (item) {
      return item.handle === GIFT_PRODUCT_HANDLE;
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
    });
  }

  function removeGift(cart) {
    var giftLine = cart.items.find(function (item) {
      return item.handle === GIFT_PRODUCT_HANDLE;
    });
    if (!giftLine) return Promise.resolve();
    var lineIndex = cart.items.indexOf(giftLine) + 1;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });
  }

  function refreshCartSections() {
    // Réutilise le pub/sub du thème Dawn pour rafraîchir le panier visuellement.
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      getCart().then(function (cart) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'auto-gift-checker', cartData: cart });
      });
    }
    // Rafraîchit aussi le drawer si présent (approche simple et robuste).
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      cartDrawerItems.onCartUpdate();
    }
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    }
  }

  function syncGift() {
    if (isSyncing) return;
    isSyncing = true;
    getCart()
      .then(function (cart) {
        var hasTrigger = cartHasTrigger(cart);
        var hasGift = cartHasGift(cart);

        if (hasTrigger && !hasGift) {
          return addGift().then(refreshCartSections);
        }
        if (!hasTrigger && hasGift) {
          return removeGift(cart).then(refreshCartSections);
        }
      })
      .catch(function (e) {
        console.error('[auto-gift-checker]', e);
      })
      .finally(function () {
        isSyncing = false;
      });
  }

  // Écoute les ajouts au panier faits via les formulaires standards du thème
  // (boutons "Ajouter au panier", quick add, etc.).
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    // Laisse le temps à l'ajout natif de se terminer avant de vérifier le panier.
    setTimeout(syncGift, 700);
  });

  // Écoute aussi le pub/sub du thème Dawn (déclenché après tout ajout/màj panier).
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'auto-gift-checker') return; // évite la boucle
      syncGift();
    });
  }

  // Vérification initiale au chargement de la page (ex: retour sur le site avec panier existant).
  document.addEventListener('DOMContentLoaded', syncGift);
})();
